<template>
  <div class="tree">
    <ul class="tree-list" v-if="tree && tree.visible">
      <TreeNode :node="tree"
                @toggle-node-opening="toggleNodeOpening"
                @toggle-node-selection="toggleNodeSelection"
                @toggle-parameter="toggleParameter"/>
    </ul>
  </div>
</template>

<script>
import TreeNode from "./TreeNode";

export default {
  components: {
    TreeNode,
  },

  props: {
    tree: {
      type: Object,
    }
  },

  methods: {
    toggleNodeOpening(node) {
      this.$emit('toggle-node-opening', node);
    },

    toggleNodeSelection(node) {
      this.$emit('toggle-node-selection', node);
    },

    toggleParameter(parameter) {
      this.$emit('toggle-parameter', parameter);
    },
  }
}
</script>

<style>
.sidebar .tree {
  margin-left: 30px;
}

.sidebar .tree-list {
  padding-left: 0;
}

.sidebar .sidebar-menu .tree-list ul {
  padding-left: 10px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Tree/Tree.vue